import { MapPickerCard } from './MapPickerCard'
import type { MapPickerConfig } from './mapPickerTypes'

type MapPickerOverlayProps = {
  config: MapPickerConfig
  onClose: () => void
}

/** Semi-translucent map overlay for operator (or future asset) selection. */
export function MapPickerOverlay({ config, onClose }: MapPickerOverlayProps) {
  const sorted = [...config.items].sort((a, b) =>
    a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }),
  )
  const title = config.title ?? 'Select'

  return (
    <div className="map-picker-overlay" role="dialog" aria-modal="true" aria-label={title}>
      <div className="map-picker-overlay-backdrop" aria-hidden onClick={onClose} />
      <div className="map-picker-overlay-panel">
        <div className="map-picker-overlay-header">
          <h2 className="map-picker-overlay-title">{title}</h2>
        </div>
        <div className="map-picker-overlay-scroll">
          {sorted.length === 0 ? (
            <p className="map-picker-overlay-empty">
              {config.emptyMessage ?? 'Nothing to show.'}
            </p>
          ) : (
            <ul className="map-picker-overlay-list">
              {sorted.map((item) => (
                <li key={item.id}>
                  <MapPickerCard item={item} onSelect={config.onSelect} />
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="map-picker-overlay-footer">
          <button type="button" className="map-picker-overlay-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
